export class ConceptForm {
    name = null;
    code = null;
    conceptFormOrderList = []
}